var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNodesSelected = function SvgNodesSelected(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3C15.552 3 16 3.448 16 4V8C16 8.552 15.552 9 15 9H13V11H17C17.552 11 18 11.448 18 12V15H20C20.552 15 21 15.448 21 16V20C21 20.552 20.552 21 20 21H14C13.448 21 13 20.552 13 20V16C13 15.448 13.448 15 14 15H16V13H8V15H10C10.552 15 11 15.448 11 16V20C11 20.552 10.552 21 10 21H4C3.448 21 3 20.552 3 20V16C3 15.448 3.448 15 4 15H6V12C6 11.448 6.448 11 7 11H11V9H9C8.448 9 8 8.552 8 8V4C8 3.448 8.448 3 9 3H15ZM9 17H5V19H9V17ZM19 17H15V19H19V17ZM14 5H10V7H14V5Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4H15V8H9V4Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16H20V20H14V16Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16H10V20H4V16Z",
    fill: "#E5E5E5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNodesSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Nodes-selected.00809519eaacf9a9e27ec38aaade62f4.svg";